<template>
	<v-dialog
		v-model="dialog.dialogOpen"
		persistent
		max-width="400"
	>
		<v-card>
			<v-card-title class="headline">{{ dialog.title }}</v-card-title>

			<v-card-text>
				¿Estás seguro?
			</v-card-text>

			<v-card-actions>
				<v-spacer></v-spacer>

				<v-btn
					color="red darken-1"
					flat="flat"
					@click="dialog.onCancel"
				>
					Cancelar
				</v-btn>

				<v-btn
					color="green darken-1"
					flat="flat"
					@click="dialog.onOk"
				>
					Aceptar
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapState } from 'vuex'
export default {
	computed: {
		...mapState(['dialog'])
	}
}
</script>
